import React, { forwardRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SvgDelete } from '../../../icons';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { ProgramSource } from '../../../queries/ats/titles/types/sources';
import { DeleteRecordingModal } from '../record-modal/delete-recording-modal';
import { FocusedAsset } from '../use-focused-asset';
import styles from './details-button.module.scss';

interface DeleteRecordingButtonProps {
  asset: Asset;
  focusedAsset: FocusedAsset;
  source: ProgramSource;
}

/**
 * - Delete a single recorded episode or movie
 * - Unless anything else is scoped
 */
export const DeleteRecordingButton = forwardRef<HTMLButtonElement, DeleteRecordingButtonProps>(
  ({ focusedAsset, source }, ref) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
      <>
        <DeleteRecordingModal
          focusedAsset={focusedAsset}
          source={source}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
        />
        <button ref={ref} className={styles.secondary} onClick={() => setIsModalOpen(true)}>
          <SvgDelete /> {t('details:delete-recording')}
        </button>
      </>
    );
  },
);
